import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { BUSINESS } from "@/data/site";

export const QuoteButton = ({ className = "", label = "Get a Free Quote", testId = "quote-btn" }) => (
  <Link
    to="/contact"
    data-testid={testId}
    className={`group inline-flex items-center gap-2 rounded-full bg-[#0B4F8A] px-7 py-3.5 font-medium text-white shadow-[0_6px_18px_rgba(16,42,67,0.20)] transition-colors duration-300 hover:bg-[#18558A] ${className}`}
  >
    {label}
    <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={2} />
  </Link>
);

export const CallButton = ({ className = "", dark = false, testId = "call-btn" }) => (
  <a
    href={BUSINESS.phoneHref}
    data-testid={testId}
    className={`inline-flex items-center gap-2 rounded-full border-2 px-7 py-3.5 font-medium transition-colors duration-300 ${
      dark
        ? "border-white/40 text-white hover:bg-white hover:text-[#102A43]"
        : "border-[#0B4F8A] text-[#0B4F8A] hover:bg-[#0B4F8A] hover:text-white"
    } ${className}`}
  >
    <Phone className="h-4 w-4" strokeWidth={2} />
    Call {BUSINESS.phone}
  </a>
);
